import { render, staticRenderFns } from "./CInput.vue?vue&type=template&id=b2ac0b0c&scoped=true"
import script from "./CInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./CInput.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CInput.vue?vue&type=style&index=0&id=b2ac0b0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ac0b0c",
  null
  
)

export default component.exports